import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { inject, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseButton',
  props: {
  size: {
    type: String,
    default: 'large',
  },
  color: {
    type: String,
    default: 'green',
  },
  shape: {
    type: String,
    default: 'sqaure',
  },
  icon: {
    type: String,
    default: '',
  },
  width: {
    type: String,
    default: '',
  },
  align: {
    type: String,
    default: 'center',
  },
  gaLabel: {
    type: String,
    default: '',
  },
  gaCategory: {
    type: String,
    default: 'feature',
  },
  gaAction: {
    type: String,
    default: 'click',
  },
  noTrack: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const $ga = inject('$ga') as any;
const route = useRoute();
const buttonRef = ref<HTMLElement | null>(null);
const inferredLabel = ref('');

const props = __props;

onMounted(() => {
  if (buttonRef.value) {
    inferredLabel.value = (buttonRef.value.textContent || '').trim();
  }
});

const handleTrackClick = () => {
  if (props.noTrack) return;
  try {
    const eventName = `${props.gaCategory}_${props.gaAction}`;
    const label = props.gaLabel || inferredLabel.value;
    $ga?.trackEvent?.(eventName, {
      label,
      color: props.color,
      size: props.size,
      page: route.name,
    });
  } catch (e) {
    // no-op
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass(`
      c-button 
      c-button--${__props.size}
      c-button--${__props.color}
      c-button--${__props.shape}
      ${__props.align && `c-button--${__props.align}`}
      ${__props.align && `c-button--${__props.align}`} 
      ${__props.icon && 'c-button--icon'}
    `),
    ref_key: "buttonRef",
    ref: buttonRef,
    onClick: handleTrackClick
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})